import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/style/common.css'
import './assets/font/iconfont.css'
import axios from './plugins/axios'
import VueLazyload from 'vue-lazyload'
import AOS from 'aos'
import 'aos/dist/aos.css'

Vue.use(ElementUI)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('./assets/img/index/logo.png'),
  loading: require('./assets/img/index/logo.png'),
  attempt: 1
})

// 设置全局属性
Vue.prototype.$baseUrl = process.env.VUE_APP_BASE_API

// 初始化AOS动画库
AOS.init({
  duration: 1000,
  easing: 'ease-in-out',
  once: true,
  mirror: false
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
